module.exports = {"id":"dp2_6l3q5","text":"Managing Digital Identity","instructions":"Who holds primary responsibility for managing personal digital identity?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":true,"options":[{"id":"dp2_6l3q5-a1","text":"The individual user","score":3.7},{"id":"dp2_6l3q5-a2","text":"The device manufacturer","score":1.3},{"id":"dp2_6l3q5-a3","text":"The internet provider","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l3q5.json
// module id = 1099
// module chunks = 41